import * as turf from '@turf/turf';
import { ILatLng, Polygon, Spherical } from "@ionic-native/google-maps";
import { Feature, Point } from "@turf/turf";
import * as tinycolor2 from "tinycolor2";

export class PolygonUtil {

	static findPolygonCenter(polygon: Polygon): ILatLng {
		let coordsTurf = PolygonUtil.coordsGoogleToTurf(polygon.getPoints().getArray());
		let polygonTurf = turf.polygon([coordsTurf]);

		let centerTurf = PolygonUtil.findCenterTurf(polygonTurf);

		let centerLatLng: ILatLng;

		if (turf.booleanPointInPolygon(centerTurf, polygonTurf)) {
			centerLatLng =
				{
					lat: centerTurf.geometry.coordinates[0],
					lng: centerTurf.geometry.coordinates[1]
				}
			console.log("Centro encontrado com turf.centerOfMass", centerTurf);
		}
		else {
			let centerTurfReduce = PolygonUtil.findCenterTurfReduce(polygonTurf);
			centerLatLng =
				{
					lat: centerTurfReduce.geometry.coordinates[0],
					lng: centerTurfReduce.geometry.coordinates[1]
				}
			console.log("Centro encontrado com turfPolygonReduce", centerTurfReduce);
		}

		return centerLatLng;
	}

	private static findCenterTurf(polygonTurf): Feature<Point> {
		return turf.centerOfMass(polygonTurf);
	}

	private static findCenterTurfReduce(polygonTurf): Feature<Point> {
		let tolerance = 0.1

		if (polygonTurf.geometry === void 0 || polygonTurf.geometry.type !== 'Polygon')
			throw ('"polygonreduce" only accepts polygon type input');

		// init defaults
		tolerance = (tolerance === void 0 || isNaN(tolerance) || tolerance === 0) ? 0.1 : Math.abs(tolerance);

		var area = turf.area(polygonTurf),

			// max number of points to force a simplify
			maxcount = /*(fine) ? 500 : 250*/ 375,

			// factor of shrinking ~ polygonTurf.area^1/2
			factor,

			// check if multiple islands and choose the bigger one
			// simplify if needed
			multi2simple = function (e) {
				var e2 = (e.features !== void 0) ? e.features[0] : e, a = 0, j = -1, p, count;
				if (e2.geometry.type == 'MultiPolygon') {
					for (let i = 0; i < e2.geometry.coordinates.length; i++) {
						p = turf.polygon(e2.geometry.coordinates[i]);
						if (turf.area(p) > a) {
							a = turf.area(p);
							j = i;
						}
					}

					e2.geometry.coordinates = [e2.geometry.coordinates[j][0]];
					e2.geometry.type = 'Polygon';
				}

				count = e2.geometry.coordinates.reduce(function (a, b) { return a + b.length; }, 0);
				return (count > maxcount) ? turf.simplify(e2) : e2;
			};

		// iteration loop, limited to area > 1 m^2 to avoid lockings
		while (area > 1) {
			factor = -1 * tolerance * Math.sqrt(area);
			try {
				polygonTurf = turf.buffer(polygonTurf, factor, { units: 'meters' });
			}
			catch (err) {
                /* it usually crashes before getting smaller than 1 m^2
                because it tries to buffer the "unbufferable" and crashes
                when processing a 0-vertex polygon (turf.js, line 12068)*/
				return turf.centroid(polygonTurf);
			}

			polygonTurf = multi2simple(polygonTurf);
			area = turf.area(polygonTurf);
		}

		// finally, if area<=1
		return turf.centroid(polygonTurf);
	}

	static calcPolygonAreaHa(polygon: Polygon): Number {
		return  Math.abs(Spherical.computeSignedArea(polygon.getPoints()) / 10000);
	}

	static coordsGoogleToTurf(coordsGoogle: ILatLng[]): number[][] {
		let coordsTurf: number[][] = [];
		coordsGoogle.forEach(function (coord) {
			coordsTurf.push([coord.lat, coord.lng]);
		});

		return coordsTurf;
	}

	static coordsTurfToGoogle(coordsTurf: number[][]): ILatLng[] {
		coordsTurf.splice(coordsTurf.length - 1);

		let coordsGoogle: ILatLng[] = [];
		coordsTurf.forEach(function (coord) {
			coordsGoogle.push({ lat: coord[0], lng: coord[1] });
		});

		return coordsGoogle;
	}

	static isPointInsidePolygon(point: ILatLng, polygon: ILatLng[]): boolean {
        return PolygonUtil.pointInPolygons(point, [polygon]).length > 0;
	}
	
	static pointInPolygons(point: ILatLng, polygons: ILatLng[][]): number[] {
        let insideList = [];

        let pointTurf = turf.point(PolygonUtil.coordsGoogleToTurf([point])[0]);
        polygons.forEach((polygon, index) => {
            let polygonTurf = turf.polygon([PolygonUtil.coordsGoogleToTurf(polygon)]);
            let isInside = turf.booleanPointInPolygon(pointTurf, polygonTurf);
            if (isInside)
                insideList.push(index);
        });

        return insideList;
	}
	
	static findReferenceNearestPolygonPoint(polygon: ILatLng[], reference: ILatLng): ILatLng {
        const turfCoordinates = PolygonUtil.coordsGoogleToTurf(polygon);
        const turfPolygon = turf.polygon([turfCoordinates]);
        const turfPolygonLine = turf.polygonToLine(turfPolygon);
        const nearestPoint = turf.nearestPointOnLine(turfPolygonLine, [reference.lat, reference.lng]);
        return {
            lat: nearestPoint.geometry.coordinates[0],
            lng: nearestPoint.geometry.coordinates[1]
        };
	}
	
	static getMarkerImage(text: string, backgroundColor: string = "#ffffff") {
        let tinyBackgroundColor = tinycolor2(backgroundColor);
        let tinyFontColor = tinycolor2("#000000");//#4a5c60

        if (tinyBackgroundColor.getBrightness() < 100) {
            tinyFontColor = tinycolor2("#ffffff");
        }

        let canvas = document.createElement("canvas");
        const size = 26;
        canvas.width = size;
        canvas.height = size;

        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, size, size);

        ctx.beginPath();
        ctx.arc(size / 2, size / 2, (size / 2) - 2, 0, 2 * Math.PI);
        ctx.fillStyle = tinyBackgroundColor.toHexString();
        ctx.fill();
        ctx.font = "bold 10px NunitoSans";
        ctx.fillStyle = tinyFontColor.toHexString();
        ctx.fillText(text, 7, 16);
        ctx.closePath();

        let base64Image = canvas.toDataURL()
        canvas.remove();

        return base64Image;
	}
	
	static getShapeImage(points: ILatLng[], size: number, color = "#0c9abe"): string {
        let immutablePoints = points.map(p => {
            return { lat: p.lat, lng: p.lng };
        });
        const margin = 10;

        // corrigir plano cartesiano em Y
        immutablePoints.forEach((item) => {
            item.lat = (item.lat - 1) * (-1);
        });

        // posicionar na origem do plano cartesiano
        let minLat = immutablePoints[0].lat;
        let minLng = immutablePoints[0].lng;
        immutablePoints.forEach((item) => {
            if (minLat > item.lat) minLat = item.lat;
            if (minLng > item.lng) minLng = item.lng;
        });

        immutablePoints.forEach((item) => {
            item.lat -= minLat;
            item.lng -= minLng;
        });

        // normalizar (valores entre 0 e 1)
        let max = 0;
        immutablePoints.forEach((item) => {
            if (max < item.lat) max = item.lat;
            if (max < item.lng) max = item.lng;
        });

        immutablePoints.forEach((item) => {
            item.lat *= (1 / max);
            item.lng *= (1 / max);
        });

        // centralizar polígono
        let maxLat = 0;
        let maxLng = 0;
        immutablePoints.forEach((item) => {
            if (maxLat < item.lat) maxLat = item.lat;
            if (maxLng < item.lng) maxLng = item.lng;
        });

        if (maxLat < maxLng) {
            immutablePoints.forEach((item) => {
                item.lat = item.lat + ((1 - maxLat) / 2);
            });
        } else {
            immutablePoints.forEach((item) => {
                item.lng = item.lng + ((1 - maxLng) / 2);
            });
        }

        // redimensionar
        immutablePoints.forEach((item) => {
            item.lng = (item.lng * size) + margin;
            item.lat = (item.lat * size) + margin;
        });

        // criar elemento canvas
        let polygonCanvas = document.createElement("canvas");
        polygonCanvas.width = size + (margin * 2);
        polygonCanvas.height = size + (margin * 2);

        // desenhar polígono
        let ctx = polygonCanvas.getContext("2d");
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.lineWidth = 4;
        ctx.clearRect(0, 0, polygonCanvas.width, polygonCanvas.height);
        ctx.beginPath();
        ctx.moveTo(immutablePoints[0].lng, immutablePoints[0].lat);
        for (let i = 1; i < immutablePoints.length; i++) {
            ctx.lineTo(immutablePoints[i].lng, immutablePoints[i].lat);
        }
        ctx.closePath();
        //ctx.fill();
        ctx.stroke();

        let base64Image = polygonCanvas.toDataURL()
        polygonCanvas.remove();

        // retornar Base64 
        return base64Image;
    }
}